<div
  class="h-toolbar w-full fixed top-0 left-0 border-b border-t-0 border-l-0 border-r-0 border-solid border-color-border flex justify-between items-center z-10 bg-white"
>
  <div class="flex h-full">
    <a class="flex items-center justify-center w-32 h-full" [href]="environment?.MOUNTDOOM_URL">
      <img class="w-[50px]" src="assets/images/logos/grid_logo.svg" alt="Grid Control" />
    </a>

    <mat-divider vertical></mat-divider>
  </div>

  <div class="flex h-full">
    <mat-divider vertical></mat-divider>
    <button
      class="flex items-center justify-center h-full w-16 text-color-secondary hover:rounded-none focus:rounded-none active:rounded-none"
      type="button"
      mat-icon-button
      [matMenuTriggerFor]="menu"
      title="Fieldnews"
    >
      <mat-icon>help</mat-icon>
      <mat-menu #menu="matMenu">
        <button class="menu-button" type="button" mat-menu-item (click)="openBlatOut()">
          <mat-icon class="text-color-icon">newspaper</mat-icon>
          <span class="text-sm"> Novidades e atualizações </span>
        </button>

        @if (false) {
          <button class="menu-button" type="button" mat-menu-item>
            <mat-icon class="text-color-icon">feedback</mat-icon>
            <span class="text-sm"> Enviar ideias e feedbacks </span>
          </button>
        }

        <button class="menu-button" type="button" mat-menu-item (click)="openLink('https://status.fieldcontrol.com.br/')">
          <mat-icon class="text-color-icon">signal_cellular_alt</mat-icon>
          <span class="text-sm"> Ver status do Gestão de Fornecedores </span>
        </button>
      </mat-menu>
    </button>
    <mat-divider vertical></mat-divider>
    <div class="relative">
      <button
        class="flex items-center justify-center h-full w-16 text-color-secondary hover:rounded-none focus:rounded-none active:rounded-none"
        type="button"
        mat-icon-button
        title="Notificações"
        (click)="openNotificationsDialog()"
      >
        <mat-icon>notifications</mat-icon>
      </button>

      @if (unreadNotificationsCount) {
        <div
          class="w-[20px] h-[20px] leading-[20px] rounded-full bg-color-danger text-center text-white font-bold text-[10px] absolute top-[33px] left-[33px] cursor-pointer pointer-events-none shadow-md"
        >
          {{ unreadNotificationsCount }}
        </div>
      }
    </div>

    <mat-divider vertical></mat-divider>

    <button
      class="flex items-center justify-center h-full w-26 px-4"
      type="button"
      mat-button
      title="Meu perfil"
      [matMenuTriggerFor]="userMenu"
    >
      <div class="flex items-center gap-2">
        <img
          class="rounded-full w-10 h-10"
          [src]="user?.avatarUrl || 'https://ui-avatars.com/api/?name=' + user?.name"
          [alt]="user?.name"
        />
        <mat-icon class="mr-0 text-color-icon text-base">expand_more</mat-icon>
      </div>
    </button>

    <mat-menu #userMenu="matMenu">
      <button type="button" (click)="profile()" mat-menu-item>
        <mat-icon class="text-color-icon">account_circle</mat-icon>
        <span class="text-sm"> Perfil </span>
      </button>

      <mat-divider class="border-t-color-border"></mat-divider>

      <button type="button" mat-menu-item (click)="logout()">
        <mat-icon class="text-color-icon">exit_to_app</mat-icon>
        <span class="text-sm"> Sair </span>
      </button>
    </mat-menu>
  </div>
</div>
